var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#f6f6f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(8 7.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.16,15.826c0-.021.012-.036.012-.058V12.421A1.323,1.323,0,0,0,15.85,11.1h-.479V1.646C15.371-.062,14.787,0,14.787,0A.585.585,0,0,0,14.2.584v3.09c-.225-.742-.654-1.542-1.151-1.542h-8.1c-.5,0-.927.8-1.153,1.543V.584A.583.583,0,0,0,3.21,0s-.583,0-.583,1.646V11.1H2.151A1.323,1.323,0,0,0,.827,12.422v3.347c0,.021.01.037.011.058A1.1,1.1,0,0,0,0,16.889,1.12,1.12,0,0,0,1.121,18.01H16.878A1.121,1.121,0,0,0,18,16.889a1.105,1.105,0,0,0-.84-1.063Z",
    transform: "translate(3 2.996)",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M6.833,5.26A1.631,1.631,0,0,1,5.2,6.89H1.63A1.631,1.631,0,0,1,0,5.26V1.631A1.631,1.631,0,0,1,1.63,0H5.2A1.632,1.632,0,0,1,6.833,1.631V5.26Z",
    transform: "translate(8.584 12.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle",
    d: "M0,1.1a1.1,1.1,0,1,1,1.1,1.1A1.095,1.095,0,0,1,0,1.1Z",
    transform: "translate(5.346 16.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle-2",
    "data-name": "Circle",
    d: "M0,1.1a1.1,1.1,0,1,1,1.1,1.1A1.095,1.095,0,0,1,0,1.1Z",
    transform: "translate(16.464 16.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M8.674,2.36a.608.608,0,0,1-.607.608H.608A.608.608,0,0,1,0,2.36V.608A.608.608,0,0,1,.608,0H8.066a.608.608,0,0,1,.607.608V2.36Z",
    transform: "translate(7.663 8.426)",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M5.376,1.409l-2.691,2.7a.791.791,0,0,1-.268.18.817.817,0,0,1-.318.064.8.8,0,0,1-.316-.064.78.78,0,0,1-.27-.18L.24,2.9a.835.835,0,0,1,0-1.172.763.763,0,0,1,.268-.185.816.816,0,0,1,.318-.063.827.827,0,0,1,.318.063.759.759,0,0,1,.268.185l.625.623,2.1-2.1A.87.87,0,0,1,4.407.064.838.838,0,0,1,4.727,0a.8.8,0,0,1,.318.064.786.786,0,0,1,.268.185.762.762,0,0,1,.2.254.835.835,0,0,1,.082.312.835.835,0,0,1-.047.319.807.807,0,0,1-.171.275Z",
    transform: "translate(9.204 13.628)",
    fill: "#0270B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs-icon.085bbd9930c81c962bcfc653faeff2b3.svg";
export { ForwardRef as ReactComponent };